// extracted by mini-css-extract-plugin
export default {"left-column-with-submenu":"LeftColumnWrapper__left-column-with-submenu___EvsKT","left-column":"LeftColumnWrapper__left-column___ciwxw"};